module.exports = __webpack_public_path__ + "media/country_flags/ir-2bfa2189.png";